import React, { useState, useEffect } from 'react';
import { 
  Calendar,
  User,
  Tag,
  Clock,
  ArrowRight,
  Search,
  TrendingUp,
  Newspaper,
  Award,
  Lightbulb,
  BookOpen,
  ChevronLeft,
  ChevronRight,
  Loader
} from 'lucide-react';
import Header from "../Header";
import Footer from "../Footer";
import api from '../api/Api';
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";




export default function NewsPage({ isDarkMode, setIsDarkMode }) {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6;
  const [allPosts, setAllPosts] = useState([]);
const [loading, setLoading] = useState(true);
const [categories, setCategories] = useState([]);
const navigate = useNavigate();
const [email, setEmail] = useState('');
const [loadingSubmit, setLoadingSubmit] = useState(false);
const URL_BASE ='https://api.angonet.ao/public/img/blog/';
//const URL_BASE = 'http://127.0.0.1:8000/storage/img/blog/';

 

const getTimeAgo = (dateString) => {
  const now = new Date();
  const past = new Date(dateString);
  const diffInSeconds = Math.floor((now - past) / 1000);

  if (diffInSeconds < 60)
    return `há ${diffInSeconds}s`;

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60)
    return `há ${diffInMinutes} min`;

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24)
    return `há ${diffInHours}h`;

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30)
    return `há ${diffInDays} dia${diffInDays > 1 ? "s" : ""}`;

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12)
    return `há ${diffInMonths} mês${diffInMonths > 1 ? "es" : ""}`;

  const diffInYears = Math.floor(diffInMonths / 12);
  return `há ${diffInYears} ano${diffInYears > 1 ? "s" : ""}`;
};


const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "");
};

const generateExcerpt = (html, maxLength = 150) => {
  const text = stripHtml(html);
  
  if (text.length <= maxLength) return text;
  
  return text.substring(0, maxLength).trim() + "...";
};



  useEffect(() => {

document.title = "Blog";

  async function fetchNoticias() {
    try {
      const response = await api.ListNoticia(); // <-- teu endpoint
      const data = response.data || response;

      // Transformar dados da API para o formato do layout
      const formattedPosts = data.map((item) => ({
        id: item.id,
        title: item.titulo,
        excerpt: generateExcerpt(item.texto, 150) + "...",
        content: item.texto,
        category: item.categoria?.toLowerCase() || "technology",
        image: `${URL_BASE}${item.img1}` || "https://via.placeholder.com/800x500",
        author: item.autor,
        date: item.created_at,
        code: item.code,
        readTime: "",
        featured: item.views > 10 // regra simples para destaque
      }));

      setAllPosts(formattedPosts);
const uniqueCategories = [
  "all",
  ...new Set(formattedPosts.map(post => post.category))
];

setCategories(uniqueCategories);


    } catch (error) {
      console.error("Erro ao buscar notícias:", error);
    } finally {
      setLoading(false);
    }
  }

  fetchNoticias();
}, []);


  // Filter posts
const filteredPosts = allPosts.filter(post => {
  const matchesCategory =
    selectedCategory === "all" || post.category === selectedCategory;

  const matchesSearch =
    post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());

  return matchesCategory && matchesSearch;
});


  // Pagination
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  // Featured posts
const featuredPosts = [...allPosts]
  .sort((a, b) => new Date(b.date) - new Date(a.date))
  .slice(0, 3);


  const getCategoryColor = (category) => {
    const colors = {
      technology: 'from-blue-500 to-cyan-500',
      security: 'from-cyan-500 to-blue-600',
      innovation: 'from-purple-600 to-violet-600',
      tutorials: 'from-blue-600 to-purple-600'
    };
    return colors[category] || 'from-gray-500 to-gray-600';
  };

const getCategoryName = (category) => {
  if (!category) return "";

  return category === "all"
    ? "Todas"
    : category.charAt(0).toUpperCase() + category.slice(1);
};


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!email) return;

  setLoadingSubmit(true);

  try {
    const payload = { email };

    const response = await api.AddContacto(payload);

    if (response) {
      toast.success('Inscrição realizada com sucesso!');
      setEmail('');
    }

  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Erro. Tente novamente.';
    toast.error(errorMsg);
  } finally {
    setLoadingSubmit(false);
  }
};



if (loading) {
  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Background igual ao resto da página */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`}></div>
      </div>

      <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

      <div className="flex flex-col items-center justify-center py-40 relative z-10">
        <div className="animate-spin rounded-full h-14 w-14 border-b-2 border-blue-600 mb-6"></div>
        
        <p className={`text-lg font-medium ${
          isDarkMode ? 'text-gray-400' : 'text-gray-600'
        }`}>
          Carregando notícias...
        </p>
      </div>

      <Footer isDarkMode={isDarkMode} />
    </div>
  );
}



  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Animated Background Particles */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`} style={{animationDelay: '1s'}}></div>
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-[100px] animate-pulse ${
          isDarkMode ? 'bg-cyan-500/5' : 'bg-cyan-400/15'
        }`} style={{animationDelay: '2s'}}></div>
        
        {/* Floating particles */}
        <div className="absolute top-[20%] left-[15%] w-1 h-1 bg-blue-500 rounded-full animate-float"></div>
        <div className="absolute top-[40%] right-[20%] w-1.5 h-1.5 bg-cyan-500 rounded-full animate-float" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-[60%] left-[30%] w-1 h-1 bg-purple-500 rounded-full animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-[80%] right-[40%] w-2 h-2 bg-blue-400 rounded-full animate-float" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute top-[30%] right-[10%] w-1 h-1 bg-cyan-400 rounded-full animate-float" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-[70%] left-[50%] w-1.5 h-1.5 bg-purple-400 rounded-full animate-float" style={{animationDelay: '2.5s'}}></div>
      </div>

      <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

      {/* Hero Section */}
      <section className={`relative pt-32 pb-20 px-6 overflow-hidden ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h1 className={`text-4xl md:text-6xl font-bold mb-6 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              Blog & <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Notícias</span>
            </h1>
            <p className={`text-xl mb-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Fique por dentro das últimas novidades em tecnologia, segurança e inovação
            </p>

            {/* Search Bar */}
            <div className="relative max-w-2xl mx-auto">
              <Search className={`absolute left-4 top-1/2 transform -translate-y-1/2 ${
                isDarkMode ? 'text-gray-500' : 'text-gray-400'
              }`} size={20} />
              <input
                type="text"
                placeholder="Pesquisar artigos..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className={`w-full pl-12 pr-4 py-4 rounded-full text-lg outline-none transition-all ${
                  isDarkMode
                    ? 'bg-gray-700 border-2 border-gray-600 text-white placeholder-gray-400 focus:border-cyan-500'
                    : 'bg-white border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:border-blue-500 shadow-lg'
                }`}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className={`border-b ${
        isDarkMode ? 'bg-gray-800/50 border-white/10' : 'bg-white border-gray-200'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-wrap gap-3 justify-center">
     {categories.map((category) => {
  const isSelected = selectedCategory === category;

  return (
    <button
      key={category}
      onClick={() => {
        setSelectedCategory(category);
        setCurrentPage(1);
      }}
      className={`flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all ${
        isSelected
          ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg scale-105'
          : isDarkMode
          ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      }`}
    >
      <span>
        {category === "all"
          ? "Todas"
          : category.charAt(0).toUpperCase() + category.slice(1)}
      </span>
    </button>
  );
})}

          </div>
        </div>
      </section>

      {/* Featured Posts */}
      {selectedCategory === 'all' && !searchQuery && (
        <section className="py-16 px-6 relative z-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <h2 className={`text-3xl md:text-4xl font-bold ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}>
                Destaques
              </h2>
              <TrendingUp className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'} size={32} />
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {featuredPosts.map((post, index) => (
                <div
                  key={post.id}
                  onClick={() => navigate(`/blog/${post.code}`)}
                  className={`group rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer ${
                    isDarkMode
                      ? 'bg-gray-800 border border-white/10 hover:border-cyan-500/50'
                      : 'bg-white border border-gray-200 hover:border-blue-500/50 shadow-lg hover:shadow-2xl'
                  }`}
                  style={{animationDelay: `${index * 0.1}s`}}
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r ${getCategoryColor(post.category)} text-white`}>
                      {getCategoryName(post.category)}
                    </div>
                  </div>

                  <div className="p-6">
                    <h3 className={`text-xl font-bold mb-3 line-clamp-2 ${
                      isDarkMode ? 'text-white group-hover:text-cyan-400' : 'text-gray-900 group-hover:text-blue-600'
                    } transition-colors`}>
                      {post.title}
                    </h3>

                    <p className={`text-sm mb-4 line-clamp-2 ${
                      isDarkMode ? 'text-gray-400' : 'text-gray-600'
                    }`}>
                      {post.excerpt}
                    </p>

                    <div className={`flex items-center justify-between text-xs ${
                      isDarkMode ? 'text-gray-500' : 'text-gray-500'
                    }`}>
                      <div className="flex items-center space-x-4">
                        <span className="flex items-center">
                          <Calendar size={14} className="mr-1" />
                          {new Date(post.date).toLocaleDateString('pt-AO')}
                        </span>
                   <span className="flex items-center">
  <Clock size={14} className="mr-1" />
  {getTimeAgo(post.date)}
</span>

                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* All Posts Grid */}
      <section className="py-16 px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          <h2 className={`text-3xl md:text-4xl font-bold mb-8 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            {searchQuery ? `Resultados para "${searchQuery}"` : 'Todos os Artigos'}
          </h2>

          {currentPosts.length === 0 ? (
            <div className="text-center py-16">
              <p className={`text-xl ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Nenhum artigo encontrado.
              </p>
            </div>
          ) : (
            <>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {currentPosts.map((post, index) => (
                  <div
                    key={post.id}
                    onClick={() => navigate(`/blog/${post.code}`)}
                    className={`group rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer ${
                      isDarkMode
                        ? 'bg-gray-800 border border-white/10 hover:border-cyan-500/50'
                        : 'bg-white border border-gray-200 hover:border-blue-500/50 shadow-lg hover:shadow-2xl'
                    }`}
                    style={{animationDelay: `${index * 0.1}s`}}
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r ${getCategoryColor(post.category)} text-white`}>
                        {getCategoryName(post.category)}
                      </div>
                    </div>

                    <div className="p-6">
                      <h3 className={`text-xl font-bold mb-3 line-clamp-2 ${
                        isDarkMode ? 'text-white group-hover:text-cyan-400' : 'text-gray-900 group-hover:text-blue-600'
                      } transition-colors`}>
                        {post.title}
                      </h3>

                      <p className={`text-sm mb-4 line-clamp-3 ${
                        isDarkMode ? 'text-gray-400' : 'text-gray-600'
                      }`}>
                        {post.excerpt}
                      </p>

                      <div className={`flex items-center justify-between pt-4 border-t ${
                        isDarkMode ? 'border-white/10' : 'border-gray-200'
                      }`}>
                        <div className="flex items-center space-x-2">
                          <User size={16} className={isDarkMode ? 'text-gray-500' : 'text-gray-400'} />
                          <span className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>
                            {post.author}
                          </span>
                        </div>

                        <div className="flex items-center space-x-2">
                          <Clock size={14} className={isDarkMode ? 'text-gray-500' : 'text-gray-400'} />
                          <span className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>
                            {getTimeAgo(post.date)}
                          </span>
                        </div>
                      </div>

                      <button className={`mt-4 flex items-center space-x-2 font-semibold transition-colors ${
                        isDarkMode ? 'text-cyan-400 hover:text-cyan-300' : 'text-blue-600 hover:text-blue-700'
                      }`}>
                        <span>Ler mais</span>
                        <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="flex items-center justify-center space-x-4 mt-12">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className={`p-3 rounded-full transition-all ${
                      currentPage === 1
                        ? isDarkMode ? 'bg-gray-800 text-gray-600 cursor-not-allowed' : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                        : isDarkMode
                        ? 'bg-gray-700 text-white hover:bg-gray-600'
                        : 'bg-white text-gray-700 hover:bg-gray-100 shadow-lg'
                    }`}
                  >
                    <ChevronLeft size={20} />
                  </button>

                  <div className="flex items-center space-x-2">
                    {[...Array(totalPages)].map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentPage(index + 1)}
                        className={`w-10 h-10 rounded-full font-semibold transition-all ${
                          currentPage === index + 1
                            ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                            : isDarkMode
                            ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                            : 'bg-white text-gray-700 hover:bg-gray-100 shadow'
                        }`}
                      >
                        {index + 1}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className={`p-3 rounded-full transition-all ${
                      currentPage === totalPages
                        ? isDarkMode ? 'bg-gray-800 text-gray-600 cursor-not-allowed' : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                        : isDarkMode
                        ? 'bg-gray-700 text-white hover:bg-gray-600'
                        : 'bg-white text-gray-700 hover:bg-gray-100 shadow-lg'
                    }`}
                  >
                    <ChevronRight size={20} />
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className={`py-20 px-6 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className={`text-3xl md:text-5xl font-bold mb-6 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Não Perca Nenhuma Novidade
          </h2>
          <p className={`text-xl mb-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Subscreva a nossa newsletter e receba as últimas notícias diretamente no seu email
          </p>
 <form
  onSubmit={handleSubmit}
  className="w-full max-w-2xl mx-auto"
>
  <div
    className={`flex items-center rounded-full overflow-hidden transition-all shadow-lg ${
      isDarkMode
        ? 'bg-gray-700 border-2 border-gray-600 focus-within:border-cyan-500'
        : 'bg-white border-2 border-gray-200 focus-within:border-blue-500'
    }`}
  >
    {/* Input */}
    <input
      type="email"
      required
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Seu e-mail"
      disabled={loadingSubmit}
      className={`flex-1 px-6 py-4 text-lg outline-none bg-transparent ${
        isDarkMode
          ? 'text-white placeholder-gray-400'
          : 'text-gray-900 placeholder-gray-500'
      } ${loadingSubmit ? 'opacity-70 cursor-not-allowed' : ''}`}
    />

    {/* Button */}
    <button
      type="submit"
      disabled={loadingSubmit}
      className={`flex items-center justify-center px-8 py-4 font-semibold text-white transition-all ${
        loadingSubmit
          ? 'bg-gradient-to-r from-blue-600 to-purple-600 opacity-80 cursor-not-allowed'
          : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:shadow-xl hover:shadow-blue-500/40'
      }`}
    >
      {loadingSubmit ? (
        <Loader size={20} className="animate-spin" />
      ) : (
        <>
          <span className="mr-2 hidden sm:inline">
            Subscrever
          </span>
          <ChevronRight size={20} />
        </>
      )}
    </button>
  </div>
</form>

        </div>
      </section>

      <Footer isDarkMode={isDarkMode} />

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
                    <ToastContainer 
                position="top-right" 
                autoClose={3000}
                toastStyle={{ borderRadius: 12 }}
              />
    </div>
  );
}